export const HOME = "lucide:home";
export const WORK = "lucide:laptop";
export const SEARCH = "lucide:search";
export const TIMESHEET_CALENDAR = "lucide:calendar-days";
export const TIMESHEET = "lucide:calendar-days";
export const TIMESHEET_WEEK = "lucide:rows-3";
export const REPORT = "lucide:file-bar-chart";
export const ORGANIZATION = "lucide:building-2";
export const PERFORMANCE = "lucide:bar-chart-4";
export const FOLDER = "lucide:folder";
export const APPS = "lucide:tablet-smartphone";
export const SORT = "lucide:arrow-up-down";
export const UP_RIGHT = "lucide:arrow-up-right";
export const LOGOUT = "lucide:log-out";
export const FILTER = "lucide:filter";
export const LIST_FILTER = "lucide:list-filter";
export const CLOSE = "mdi:close";
export const CIRCLE_CHECK = "lucide:circle-check";
export const PLUS = "lucide:plus";
export const EDIT = "lucide:pencil";
export const CHECK = "lucide:check";
export const CHECK_CHECK = "lucide:check-check";
export const LOADER2 = "lucide:loader-circle";
export const TRIANGLE_ALERT = "lucide:triangle-alert";
export const CALENDAR = "lucide:calendar";
export const UP = "lucide:chevron-up";
export const DOWN = "lucide:chevron-down";
export const LEFT = "lucide:chevron-left";
export const RIGHT = "lucide:chevron-right";
export const UP_DOWN = "lucide:chevrons-up-down";
export const INBOX = "lucide:inbox";
export const THUMBS_UP = "lucide:thumbs-up";
export const CIRCLE_CHECK_BIG = "lucide:circle-check-big";
export const USER = "lucide:user";
export const LOCK = "lucide:lock-keyhole";
export const LOCK_OPEN = "lucide:lock-keyhole-open";
export const FLAG = "lucide:flag";
export const ARROWRIGHTFROMLINE = "lucide:arrow-right-from-line";
export const FORWARD = "lucide:arrow-right";
export const BACK = "lucide:arrow-left";
export const ARROW_LEFT_RIGHT = "lucide:arrow-left-right";
export const CIRCLE_X = "lucide:circle-x";
export const DASHBOARD = "lucide:layout-dashboard";
export const BASICDETAILS = "lucide:notepad-text";
export const OTHERDETAILS = "lucide:notebook-text";
export const JOB = "lucide:briefcase-business";
export const BILLABLE = "lucide:banknote";
export const TIMESHEET_CARD = "lucide:captions";
export const TIMESHEET_TABLE = "lucide:rows-3";
export const LIST = "lucide:list";
export const GRID = "lucide:layout-grid";
export const BREIFCASE = "lucide:briefcase-business";
export const DAY = "lucide:sun";
export const EYE_OPEN = "lucide:eye";
export const EYE_CLOSE = "lucide:eye-off";
export const CIRCLE = "lucide:circle";
export const DOLLAR = "lucide:dollar-sign";
export const CLOCK = "lucide:clock";
export const PIECHART = "lucide:chart-pie";
export const BUDGET = "lucide:wallet";
export const ALLOCATION = "lucide:chart-pie";
export const MILESTONES = "lucide:flag-triangle-right";
export const WORK_IN_PROGRESS = "lucide:hammer";
export const CIRCLE_ALERT = "lucide:circle-alert";
export const ADD_USER = "lucide:user-round";
export const MILESTONE = "lucide:flag-triangle-right";
export const PENDING_REVIEW = "lucide:clipboard-clock";
export const COPY = "lucide:copy";
export const USERS = "lucide:users";
export const MAIL = "lucide:mail";
export const MENU = "lucide:ellipsis-vertical";
export const EXTENSIONS = "lucide:calendar-plus";
export const FIXED = "lucide:dollar-sign";
export const HOURLY = "lucide:clock";
export const DEDICATED = "lucide:user";
export const RECURRING = "lucide:repeat";
export const BUCKET = "lucide:popcorn";
export const FREE = "lucide:circle-slash";
export const REWARD = "lucide:gift";
export const BADGE = "lucide:award";
export const AWARD = "lucide:trophy";
export const PROJECT = "lucide:building-2";
export const CONFIG = "lucide:sliders-horizontal";
export const INTEGRATIONS = "lucide:blocks";
export const DRIVE = "logos:google-drive";
export const GITHUB = "logos:github-icon";
export const DISCORD = "skill-icons:discord";
export const KEKA = "token-branded:kda-background";
export const LINK = "lucide:square-arrow-out-up-right";
export const IMGUPLOAD = "lucide:image-up";
export const X = "lucide:x";
export const INFO = "lucide:info";
export const REDIRECT = "lucide:external-link";
export const REPORTS = "lucide:file-chart-column-increasing";
// export const PERFORMANCE = "lucide:chart-column-increasing";
export const HOUSE = "lucide:house";
export const SERVICES = "lucide:layers";
export const ANALYTICS = "lucide:chart-no-axes-column-increasing";
export const REVENUE = "lucide:circle-dollar-sign";
export const BOOKMARKS = "lucide:bookmark-plus";
export const CRM = "lucide:contact-round";
export const DARKDISCORD = "simple-icons:discord";
export const IMAGE = "lucide:image";
export const BARCHART = "lucide:chart-column-big";
export const AVERAGE = "lucide:chart-line";
export const SUBMITTED = "lucide:check";
export const PENDING = "lucide:loader-circle";
export const PULL_REQUEST = "lucide:git-pull-request-arrow";
export const SUPPORT = "lucide:headset";
export const TAG = "lucide:tag";
export const FILETEXT = "lucide:file-text";
export const SETTINGS2 = "lucide:settings-2";
export const PUZZLE = "lucide:puzzle";
export const BADGECHECK = "lucide:badge-check";
export const CPU = "lucide:cpu";
export const PACKAGE = "lucide:package";
export const MESSAGE = "lucide:message-square";
export const VIDEO = "lucide:square-play";
export const TRENDINGUP = "lucide:trending-up";
export const ANNOUNCEMENT = "lucide:megaphone";
export const DATABASE = "lucide:database";
export const DOWNLOAD = "lucide:arrow-down-to-line";
export const SHARE = "lucide:share-2";
export const RENAME = "lucide:pencil-line";
export const ROUND = "lucide:circle";
export const DELETE = "lucide:trash";
export const CONTRACT = "lucide:scroll-text";
export const PRESALES = "lucide:text-select";
export const PENDING_SELF_REVIEW = "lucide:user-check";
export const REVIEWER_LOAD = "lucide:clipboard-list";
export const REVIEW_COVERAGE = "lucide:user-cog";
export const MOVE_RIGHT = "lucide:move-right";
export const CASESTUDIES = "lucide:square-library";
export const INTERVIEWS = "lucide:mic-vocal";
export const ESTIMATION = "lucide:hourglass";
export const DRAFT = "lucide:pencil-line";
export const FEEDBACKS = "lucide:message-square-share";
export const CONTACTS = "lucide:contact";
export const SURVEY = "lucide:smile";
export const PHONE = "lucide:phone";
export const FACEBOOK = "simple-icons:facebook";
export const LINKEDIN = "simple-icons:linkedin";
export const WHATSAPP = "simple-icons:whatsapp";
export const TELEGRAM = "simple-icons:telegram";
export const SKYPE = "simple-icons:skype";
export const SPARKLES = "lucide:sparkles";
export const AMOUNTLOCK = "lucide:lock";
export const AMOUNTUNLOCK = "lucide:lock-open";
export const RESPONSIBILITIES = "lucide:handshake"
export const TASK = "lucide:list-todo"
export const REFRESH = "lucide:rotate-cw"